"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ColonySpace_vue_1 = __importDefault(require("./ColonySpace.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'ColonyRow',
    components: {
        ColonySpace: ColonySpace_vue_1.default,
    },
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        colony: {
            type: Object,
            required: true,
        },
    },
});
